export interface Servico {
  id: number;
  nome: string;
  usuario: boolean;
  proprietario: boolean;
  descricao: string;
  comMatricula: boolean;
  informacoes: string;
  explicativo?: string;
  termoAceite?: string;
  termoAceiteDescricao?: string;
  solicitarDetalhesEndereco: boolean;
  solicitarFotoIdentificacao: boolean;
  servicoFormulario: ServicoFormulario[];
  servicoAnexos: ServicoAnexo[];
  descricaoDocumentoIdentificacao: string;
  linkDeclaracoes: string;
  slug: string;
  mensagemMatricula?: string;
}

export interface ServicoFormulario {
  id: number;
  label: string;
  ordem: number;
  servicoValores: ServicoFormularioCampo[];
}

export interface ServicoFormularioCampo {
  id: number;
  valor: string;
  ordem: number;
}

export interface ServicoAnexo {
  id: number;
  label: string;
  nomeAnexo: string;
  ordem: number;
  envioObrigatorio: boolean;
}

export interface FormularioBuscaUnidade {
  tipoUsuarioUnidade?: string;
  cpfCnpjUnidade?: string;
  matricula?: number;
  id?: number;
}

export interface DadosUnidade extends FormularioBuscaUnidade {
  digitoVerificador: number;
  enderecoCompleto: string;
  clienteNome: string;
  municipioId: number;
  mensagemMatricula?: string;
}

export interface DadosSolicitante {
  nomeSolicitante?: string | null | undefined;
  cpfSolicitante?: string | null | undefined;
  emailSolicitante?: string | null | undefined;
  telefoneSolicitante?: string | null | undefined;
  tipoUsuario?: string | null | undefined;
  municipioId?: number | null | undefined;
  endereco?: string | null | undefined;
  complementoEndereco?: string | null | undefined;
  bairro?: string | null | undefined;
}

export interface CategoriasServico {
  label: string;
  servicos: Array<LinkServicos>;
}

export interface LinkServicos {
  label: string;
  imagem: string;
  externo: boolean;
  link: string;
}

export interface ServicoInterno {
  nome: string;
  slug: string;
}

export interface Municipio {
  id: number;
  nome: string;
}

export interface FormularioServico {
  informacoesServicoSolicitado: string;
  servicoValores: Number[] | undefined;
}

export interface FormularioServicoComArquivos extends FormularioServico {
  anexos: File[];
}

export interface FormularioCompleto
  extends FormularioServico,
  DadosSolicitante {
  servicoId?: number;
  matricula?: number;
  digitoMatricula?: number;
  cpfCnpjUnidade?: string;
  nomeUsuarioUnidade?: string;
  tipoUsuarioUnidade?: string;
  origem: string;
}

export class IdentificacaoAtendimento {
  constructor(public id: number, public ano: number, public hash: string) { }

  get codigoFormatado(): string {
    return IdentificacaoAtendimento.formatarCodigo(this.id, this.ano);
  }

  static formatarCodigo(id: number, ano: number): string {
    return 'AD' + String(id).padStart(7, '0') + '/' + ano;
  }
}
export class DadosAtendimento extends IdentificacaoAtendimento {
  constructor(
    override id: number,
    override ano: number,
    override hash: string,
    public servico: string,
    public situacao: { code: string; description: string },
    public dataCadastro: Date,
    public dataSituacao: Date,
    public localidade: string,
    public podeEnviarArquivoComplementar: boolean,
    public qtdArquivoComplementar: number,
    public justificativa?: string,
    public protocolo?: string,
    public situacaoServico?: { code: string; description: string }
  ) {
    super(id, ano, hash);
  }

  static fromResponse({
    id,
    ano,
    hash,
    servico,
    situacao,
    dataCadastro,
    dataSituacao,
    localidade,
    podeEnviarArquivoComplementar,
    qtdArquivoComplementar,
    justificativa,
    protocolo,
    situacaoServico,
  }: DadosAtendimento) {
    return new DadosAtendimento(
      id,
      ano,
      hash,
      servico,
      situacao,
      dataCadastro,
      dataSituacao,
      localidade,
      podeEnviarArquivoComplementar,
      qtdArquivoComplementar,
      justificativa,
      protocolo,
      situacaoServico
    );
  }
}

export class ConsultaProtocolo {
  constructor(
    public dtHoraSoltcao: Date,
    public matricula: Number,
    public codigo: Number,
    public situacao: Number,
    public texto: String
  ) { }

  static fromResponse(res: ConsultaProtocolo): ConsultaProtocolo {
    return new ConsultaProtocolo(
      new Date(res.dtHoraSoltcao),
      res.matricula,
      res.codigo,
      res.situacao,
      res.texto ?? ''
    );
  }

  get protocoloFormatado(): string {
    const dia = this.dtHoraSoltcao.getDate().toString().padStart(2, '0');
    const mes = (this.dtHoraSoltcao.getMonth() + 1).toString().padStart(2, '0');
    const ano = this.dtHoraSoltcao.getFullYear();
    const hora = this.dtHoraSoltcao.getHours().toString().padStart(2, '0');
    const minuto = this.dtHoraSoltcao.getMinutes().toString().padStart(2, '0');

    return `${dia}/${mes}/${ano} ${hora}:${minuto} ${this.matricula}`;
  }
}
